import workSheetService from '../../services/workSheet.service';

export default {
    namespaced: true,
    state: {
        worksheet: {},
        enrolledTrainings: null,
        score: null,
        allscore: null,
        progress: [],
        trainingScore: null,
        trainingStatus: [],
        taskScore:[]
    },
    getters: {
        getWorkSheet: (state) => state.worksheet,
        getEnrolledTrainings: (state) => state.enrolledTrainings,
        getWorksheetScore: (state) => state.score,
        getAllScore(state) {
            let name = [],
                score = [];
            state.allscore?.map((item) => {
                name.push(item.userName), score.push(item.score);
            });
            return { name, score };
        },
        getProgress: (state) => state.progress,
        getTrainingScore(state) {
            return state.trainingScore;
        },
        getTrainingStatus(state) {
            return state.trainingStatus;
        },
        getTaskScore(state){
            return state.taskScore
        }
    },
    mutations: {
        setWorkSheet(state, payload) {
            state.worksheet = payload;
        },
        setEnrolledTrainings(state, payload) {
            state.enrolledTrainings = payload;
        },
        setWorksheetScore(state, payload) {
            state.score = payload;
        },
        setAllScore(state, payload) {
            state.allscore = payload;
        },
        setProgress(state, payload) {
            state.progress = payload;
        },
        setTrainingScore(state, payload) {
            state.trainingScore = payload;
        },
        setTrainingStatus(state, payload) {
            state.trainingStatus = payload;
        },
        setTaskScore(state,payload){
            state.taskScore = payload
        }
    },
    actions: {
        GET_WORKSHEET_BY_ID({ commit }, id) {
            workSheetService.getworkSheetById(id, {
                success: ({ data }) => {
                    commit('setWorkSheet', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                    // errorCallback(error);
                },
            });
        },
        GET_WORKSHEET_BY_ID_BY_ADMIN({ commit }, { id, userId }) {
            workSheetService.getworkSheetByIdByAdmin(id, userId, {
                success: ({ data }) => {
                    commit('setWorkSheet', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                    // errorCallback(error);
                },
            });
        },
        GET_ENROLLED_TRAININGS_BY_USER_ID({ commit }, { id = 0, size = 60, page = 1, name = '', status = '' }) {
            workSheetService.getworkSheetByUserId(
                id,
                {
                    params: {
                        size,
                        page,
                        name,
                        status,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setEnrolledTrainings', data.data.moduleDetails);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },
        CHECK_TRAINING_ENROLLMENT_FOR_USER(context, { payload, successCallback, errorCallback }) {
            workSheetService.checkTrainingEnrollment(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        CREATE_COMMENT_FOR_WORKSHEET(context, { payload, successCallback, errorCallback }) {
            workSheetService.createCommentForWorksheet(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        SET_WORKSHEET_SCORE(context, { payload, successcallback, errorcallback }) {
            workSheetService.setScoreForWorksheet(payload, {
                success: (res) => {
                    // commit('setWorksheetScore',res.data)
                    // console.log("set score successfull",res)
                    successcallback && successcallback(res);
                },
                error: (err) => {
                    errorcallback && errorcallback(err);
                },
            });
        },
        GET_WORKSHEET_SCORE({ commit }, worksheetId) {
            workSheetService.getScoreForWorksheet(worksheetId, {
                success: (res) => {
                    commit('setWorksheetScore', res.data.data);
                },
                error: (err) => {
                    console.log(err);
                },
            });
        },
        GET_ALL_SCORE({ commit }, trainingId) {
            workSheetService.getAllScore(trainingId, {
                success: (res) => {
                    commit('setAllScore', res.data.data);
                },
                error: (err) => {
                    console.log(err);
                },
            });
        },
        GET_PROGRESS_BY_TRAINING_ID({ commit }, trainingId) {
            workSheetService.getProgressByTrainingId(trainingId, {
                success: (res) => {
                    commit('setProgress', res.data.data);
                },
                error: (err) => {
                    console.log(err);
                },
            });
        },
        GET_TRAINING_SCORE({ commit }, { trainingId, page = 1, size = 10 }) {
            workSheetService.getTrainingScore(
                {
                    params: {
                        size,
                        page,
                        trainingId,
                    },
                },
                {
                    success: (res) => {
                        let arr = [];
                        let data = res.data.data;
                        for (const task in data.tasks) {
                            if (task != 'Total') {
                                arr.push(data.tasks[task]);
                            }
                        }

                        let score_arr = [];
                        let total = [];
                        data.data.map((userdata) => {
                            let temp = [];
                            for (const id in userdata.userData) {
                                if (id != 'Total') {
                                    temp.push(userdata.userData[id]);
                                }
                            }
                            score_arr.push(temp);
                        });

                        // res.data.data.map((data)=>{
                        let structuredData = [];
                        for (let i in score_arr) {
                            structuredData.push({ name: data.data[i].userName, data: score_arr[i] });
                            total.push(data.data[i].userData.Total);
                        }

                        let training = {
                            name: { categories: arr },
                            data: structuredData,
                            total,
                        };

                        // })
                        commit('setTrainingScore', training);
                        console.log(res);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                }
            );
        },
        GET_TRAINING_STATUS({ commit }, { id, page = 1, size = 10 }) {
            workSheetService.getTrainingStatus(
                {
                    params: {
                        size,
                        page,
                        trainingId: id,
                    },
                },
                {
                    success: (res) => {
                        let arr = [];
                        let data = res.data.data;
                        for (const task in data.tasks) {
                            arr.push(data.tasks[task]);
                        }

                        let score_arr = [];
                        let total = [];
                        data.data.map((userdata) => {
                            let temp = [];
                            for (const id in userdata.userData) {
                                temp.push(userdata.userData[id]);
                            }
                            score_arr.push(temp);
                        });

                        // res.data.data.map((data)=>{
                        let structuredData = [];
                        for (let i in score_arr) {
                            structuredData.push({ name: data.data[i].userName, data: score_arr[i] });
                            total.push(data.data[i].userData.Total);
                        }
                        let trainingstatus = {
                            taskname: arr,
                            structuredData,
                        };
                        commit('setTrainingStatus', trainingstatus);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                }
            );
        },

        GET_TASK_SCORE({commit}, { payload, adminId }) {
            // console.log(payload)
            workSheetService.getTaskScore(
                adminId,
                {
                    params: {
                        userId: payload.userId,
                        trainingId: payload.trainingId,
                    },
                },
                {
                    success:(res)=>{
                        commit('setTaskScore',res.data.data)
                    },
                    error:(err)=>{
                        console.log(err)
                    }
                }
            );
        },
        
    },
};
